export const environment = {
    production: false,
    env: 'test',
    apiHost: 'https://api.cfainframannp-dev.cfadevelop.com',
    oktaHost: 'https://cfahome.oktapreview.com/oauth2/ause935uhauRMpJuP0h7/v1/token',
    clientId: '0oaog8pbe9Xg6CHPX0h7',
    redirectUrl: 'https://networkhealth.cfainframannp-test.cfadevelop.com',
    idmUrl: 'https://auth.idm-dev.cfadevelop.com/oauth2/token',
    oktaIssuerUrl: 'https://cfahome.oktapreview.com/oauth2/ausc6e4sj2fnPnQ670h7',
    oktaUrl: 'https://cfahome.oktapreview.com',
    oktaApiBaseUrl: 'https://api.idm-dev.cfadevelop.com',
    locationApiHost: 'https://location.api.qa.crndev.chick-fil-a.com',
    netboxUrl: 'https://app.netboxtest.cfadevelop.com',
    mistUrl: 'https://manage.mist.com'
  };
  